var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c("div", [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$t("duty.editModal.help.video.link").toString(),
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("duty.editModal.help.video.title")) +
                      "\n          "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("iframe", {
              attrs: {
                src: _vm.$t("duty.editModal.help.video.src").toString(),
                width: "464",
                height: "261",
                frameborder: "0",
                allow: "autoplay; fullscreen",
                allowfullscreen: ""
              }
            })
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }